import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';

const VideoPlayer = ({ videoData, visible, onClose }) => {
    const [playerSize, setPlayerSize] = useState({ width: 408, height: 726 });

    useEffect(() => {
        const calculateSize = () => {
            const windowHeight = window.innerHeight;
            const defaultWidth = 408;
            const defaultHeight = 726;
            const aspectRatio = defaultWidth / defaultHeight; // 408 / 726

            let width = defaultWidth;
            let height = defaultHeight;

            // 如果浏览器高度不足726，则高度为浏览器高度，宽度按比例缩小
            if (windowHeight < defaultHeight) {
                height = windowHeight;
                width = height * aspectRatio;
            }

            setPlayerSize({ width, height });
        };

        // 初始化计算
        calculateSize();

        // 监听窗口大小变化
        window.addEventListener('resize', calculateSize);

        return () => {
            window.removeEventListener('resize', calculateSize);
        };
    }, []);

    if (!visible || !videoData) {
        return null;
    }

    return (
        <div className={styles.playFixBox}>
            <div className={styles.playFix}>
                <Player
                    key={videoData.guid}
                    videoConfig={{
                        videoPlayUrl: videoData.videoPlayUrl,
                        duration: Number(videoData.duration),
                        vid: videoData.guid,
                    }}
                    playermsg={{
                        subject: 'jiushiju2025',
                        adType: 2,
                        width: playerSize.width,
                        height: playerSize.height,
                        autoPlay: true,
                        controls: true,
                    }}
                />
                <div className={styles.close} onClick={onClose} />
            </div>
        </div>
    );
};

VideoPlayer.propTypes = {
    videoData: PropTypes.object,
    visible: PropTypes.bool,
    onClose: PropTypes.func,
};

export default errorBoundary(VideoPlayer);
